import { Direction } from './tooltip.type';
export var defaultTooltipDirection = Direction.down;
// Minimum number of pixels between triangle cursor and origin
export var minimumVerticalSpace = 16;
export var triangleBaseSize = 8;
export var transitionDistance = 12;
export var triangleWidth = 2;
export var animationTiming = '0.2s';
export var messageWidth = 280;
export var halfMessageWidth = 140;
export var minSpaceBetweenOriginAndContainer = halfMessageWidth + triangleBaseSize;
export var defaultTriangleOffsetLeft = halfMessageWidth - triangleBaseSize;
